import React, { FC } from 'react';
import classNames from 'classnames';
import { get, join, slice } from 'lodash';
import { useQuery } from '@apollo/client';

import SettingsItem from './SettingsItem';
import Icon, { IconmoonFont } from 'vibo-ui/Icon';
import Button, { ButtonDecor } from 'vibo-ui/Button';

import { useModal } from 'vibo-ui/Modal';
import { useMe } from 'graphql/hooks/user';

import { GET_PAYMENT_METHOD_SUMMARY } from 'graphql/queries/payment';

import { Modals } from 'types/enums';

import useStyles from './style';

const ChangeCard: FC = () => {
  const classes = useStyles();

  const { isChildDj } = useMe();

  const { openModal } = useModal();

  const { data } = useQuery<TypeGetpaymentMethodSummaty>(GET_PAYMENT_METHOD_SUMMARY, {
    fetchPolicy: 'cache-and-network',
    skip: isChildDj,
  });
  const paymentData = data?.getPaymentMethodSummary;

  const last4 = get(paymentData, 'last4', '');
  const month = get(paymentData, 'expMonth', '');
  const displayName = get(paymentData, 'displayName', '');
  const year = paymentData ? join(slice(paymentData.expYear, 2, 5), '') : '';
  const isCardAdded = !!last4;

  return (
    <SettingsItem>
      <div
        className={classNames('label', classes.label, {
          noCard: !isCardAdded,
        })}
      >
        <Icon icon={IconmoonFont['creditCard-24']} className={classes.generalIcon} />
        <b>{displayName || `XXXX-XXXX-XXXX-XXXX`}</b>
        {month && year ? (
          <b className={classNames(classes.expiredDate)}>{`${month || 'MM'}/${year || 'YY'}`}</b>
        ) : null}
      </div>
      <Button
        onClick={() =>
          openModal({
            key: Modals.changeStripePayment,
          })
        }
        prefixIcon={IconmoonFont['arrowLeftRight-16']}
        className={ButtonDecor.primaryColor}
        displayType="link"
      >
        Payment details
      </Button>
    </SettingsItem>
  );
};

export default ChangeCard;
